const isNotNullFirstname = (data) => {
  const key = 'isNotNullFirstname'
  const { value } = data
  const isEmpty = value === '' || value === null ? true : false
  const error = isEmpty ? key : false
  return error ? { error, data } : false
}

export default isNotNullFirstname
